module.exports = __webpack_public_path__ + "img/whiteuparrow.92f35f72.svg";